/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The type of Guesty entity an event refers to
 */
export type GuestyEventEntityType = 'RESERVATION' | 'LISTING';

export const GuestyEventEntityType = {
    RESERVATION: 'RESERVATION' as GuestyEventEntityType,
    LISTING: 'LISTING' as GuestyEventEntityType
};

